import { jsx } from "panel";
export function template() {
  const {
    dateObj
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".date-input-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("input", { attrs: {
    type: "text",
    placeholder: dateObj && this.helpers.formatDate(dateObj) || ""
  }, class: {
    error: this.isAttributeEnabled("error")
  }, on: {
    focus: this.helpers.focusedInput,
    blur: this.helpers.blurredInput,
    change: this.helpers.changedInput
  } }));
}
